import React from 'react'
import { Redirect, useLocation } from 'react-router-dom'

/* There isn't much actual logic to test here, and setting up
all of the react-router-dom mocks would be more effort than it's worth */

/* istanbul ignore file */

export const DefaultRedirector: React.FC = () => {
  const location = useLocation()
  const accountId = new URLSearchParams(location.search).get('accountId')

  // mobile support default deeplink
  if (accountId) {
    return <Redirect to={{ pathname: `/account/${accountId}/details` }} />
  }
  return <Redirect to="/dashboard" />
}
